/*
*
* JobOportunities
*
*/

import React from 'react';
import { connect } from 'react-redux';
import { setTitle, delayedDispatch, setBreadcrumb, updateCrumb, setLoader } from 'store/actions';
import { Helmet } from 'react-helmet';
import { Table } from 'components';
import { API , Endpoints } from 'utils/api';
import { push } from 'connected-react-router';
import Strings from 'utils/strings';
import { toast } from "utils/utils";
import './styles.scss';

export class JobOportunities extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			jobOportunities: [],
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		dispatch(setTitle(Strings.sidebar.jobOportunities));

		delayedDispatch(
            setBreadcrumb(() => {
                return {
                    locations: [
						{
							text: Strings.sidebar.jobOportunities,
							icon: "text-files",
						},
					],
                }
            })
		);

		this.getJobOportunities();
	}

	componentDidUpdate() {
		const { dispatch } = this.props;
        dispatch(updateCrumb());
	}
	onAdd() {
		const { dispatch } = this.props;
		dispatch(push("/job-oportunities/new"));
	}

	getJobOportunities = async () => {
		const response = await API.get({
			url: Endpoints.uriJobOportunities(),
		});
		
		if (response.ok) {
			const { jobOportunities } = response.data.results;
			this.setState({ jobOportunities });
		}
	}

	patchJobOportunity = async ( original : any) =>{
		let body = {isActive: !original.isActive};
		const response= await API.patch({
			url: Endpoints.uriJobOportunities(original._id),
			data: body,
		});

		if(response.ok){
			this.setState({ jobOportunities: response.data.results.jobOportunities });
		}
	}

	onDrag = async () => {
		const { jobOportunities, hoverIndex } = this.state;
		const { dispatch } = this.props;
	
		const jobOportunity = jobOportunities[hoverIndex];
		const jobOportunityId = jobOportunity?._id;
	
		// if (!jobOportunityId || jobOportunity.pos === hoverIndex) return;
	
		dispatch(setLoader(true));
	
		await API.patch({
			url: Endpoints.uriJobOportunities(`position/${jobOportunityId}`),
			data: { pos: hoverIndex },
		})
			.then((response) => {
				if (response.ok && response.data.results.jobOportunities) {
				this.setState({ jobOportunities: response.data.results.jobOportunities });
				} else
				toast.error(response.data?.message || Strings.serverErrors.title);
			})
			.catch((err) => {
				toast.error(err);
			});
	
		dispatch(setLoader(false));
	};

	render() {
		const { jobOportunities = [] } = this.state;
		const { dispatch } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.jobOportunities}</title>
					<meta name="description" content="Description of Job Oportunities" />
				</Helmet>
				<Table
					title={{
						icon: "working-briefcase",
						title: Strings.sidebar.jobOportunities
					}}
					data={jobOportunities}
					columns={[
						{
							Header: Strings.jobOportunities.single,
							id: 'name',
							accessor: (row: any) => row.title,
						},
					]}
					draggable
					paginated={false}
					isSinglePage
					onDrag={async (list: any, dragIndex: any, hoverIndex: any) => {
						this.setState({ jobOportunities: list, dragIndex, hoverIndex })
					}}
					onDragEnd={this.onDrag}
					add={{
						label: String(
							Strings.formatString(
								Strings.generic.addNewM,
								Strings.jobOportunities.single.toLowerCase()
							)
						),
						onClick: () => this.onAdd(),
					}}
					actions={{
						edit: (original, value) => ({
							onClick: () => dispatch(push(`/job-oportunities/${original._id}`)),
						}),
						toggle: (original, value) =>({
							value: original.isActive,
							onChange: () => this.patchJobOportunity(original),
						})
					}}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps)(JobOportunities);